import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { AvailableCompositions } from '../models/segments';
import { AppContext, AppProviderDispatch } from '../shared/app-context';
import useRestService from '../shared/rest-service';

/**
 * Hook to fetch a client user a list of available segments
 */
export function useAvailableCompositions(segmentId: string) {
  const appState = React.useContext<AppProviderDispatch>(AppContext);
  const { fetchWrapper } = useRestService();

  return useQuery<AvailableCompositions[], Error>(
    ['available-compositions', appState.state.clientId, segmentId],
    () => {
      return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}/available-compositions`);
    },
    {
      keepPreviousData: true
    }
  );
}
